import axios from 'axios';
import qs from 'qs';
import saveAs from 'file-saver';

import {translate, translateValidation} from './trans';
import {setError} from "../services/actions/error";
import {setUser} from "../services/actions/user";


import store from "../store";

import {
    HTTP_INTERNAL_ERROR,
    HTTP_NOT_ACCEPTABLE, HTTP_NOT_FOUND,
    HTTP_UNAUTHORIZED,
    HTTP_BAD_REQUEST
} from "../services/constants";

class Http {
    constructor() {
        axios.defaults.headers.patch['Content-Type'] = 'application/x-www-form-urlencoded';
        axios.interceptors.request.use((request) => {
            if (request.data && request.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
                request.data = qs.stringify(request.data);
            }
            return request;
        });
        this._axios = axios.create({});
        this._url = process.env.REACT_APP_API_URL;
        this._apiMethod = false;
        this._response = false;
        this._error = false;
    }

    _validate() {
        if (!this._apiMethod) {
            throw new Error('Method was not specified.');
        }
    }

    route(apiMethod) {
        this._apiMethod = apiMethod;
        return this;
    }

    static _getAuthConfig() {
        let axiosConfig = {};

        const jwt = sessionStorage.getItem('jwt');

        if (jwt) {
            axiosConfig = Object.assign({}, {
                headers: {'Authorization': 'Bearer ' + jwt}
            });
        }

        return axiosConfig;
    }

    build() {
        let response = this._response && this._response.data ? {...this._response.data} : false;
        this._response = false;

        let isError = false;
        let errorMessage = {};
        let data = false;
        let pagination = false;

        if (response) {
            if (response.responseType && response.responseType === 'success') {
                data = response.data.result;
                pagination = response.data.pagination !== null ? response.data.pagination : false;
            } else {
                data = response.data;
                isError = true;
                if (typeof response.errorMessage === 'object') {

                    for (let error in response.errorMessage) {
                        if (response.errorMessage.hasOwnProperty(error)) {
                            if(error === 'error'){
                                errorMessage = {...errorMessage, ...response.errorMessage[error]};
                            }else{
                                if (Array.isArray(response.errorMessage[error])) {
                                    errorMessage = {...errorMessage, [error]: translateValidation(error, response.errorMessage[error][0])};
                                } else {
                                    errorMessage = {...errorMessage, [error]: translateValidation(error, response.errorMessage[error])};
                                }
                            }

                        }
                    }
                } else {

                    errorMessage = {error: translate(response.errorMessage)};

                    if (response.errorMessage === 'errors.rememberToken.invalid') {
                        localStorage.removeItem('rememberToken');
                        window.location.reload();
                    }
                    if (response.errorMessage === 'errors.token') {
                        sessionStorage.removeItem('jwt');
                        window.location.reload();
                    }

                    if (response.errorMessage === 'errors.error') {
                        store.dispatch(setError(errorMessage.error));
                    }

                    if (response.errorMessage === 'errors.suspended') {
                        let user = store.getState().user.user;
                        user.suspended_screen = true;
                        store.dispatch(setUser(user));
                    }
                }
            }
        } else {
            let error = translate('misc.api');
            isError = true;
            errorMessage = {error};

            store.dispatch(setError(error));
        }

        return {
            isError,
            errorMessage,
            data,
            pagination
        };
    }

    buildError(status) {
        let errorData = this._error ? {...this._error} : false;
        this._error = false;

        let isError = false;
        let errorMessage = {};
        let data = false;
        let pagination = false;
        let isNotFound = false;

        if (errorData) {
            isError = true;
            if (typeof errorData.errorMessage === 'object') {
                for (let error in errorData.errorMessage) {
                    if (errorData.errorMessage.hasOwnProperty(error)) {
                        if (Array.isArray(errorData.errorMessage[error])) {
                            errorMessage = {...errorMessage, [error]: translateValidation(error, errorData.errorMessage[error][0])};
                        } else {
                            errorMessage = {...errorMessage, [error]: translateValidation(error, errorData.errorMessage[error])};
                        }
                    }
                }
            } else {
                if (status === HTTP_NOT_ACCEPTABLE && errorData.errorMessage === 'errors.rememberToken.invalid') {
                    localStorage.removeItem('rememberToken');
                    window.location.reload();
                }

                if (status === HTTP_UNAUTHORIZED) {
                    sessionStorage.removeItem('jwt');
                    window.location.reload();
                }

                if (status === HTTP_BAD_REQUEST) {
                    window.location.href = '/';
                }

                errorMessage = {error: translate(errorData.errorMessage)};

                if (status === HTTP_INTERNAL_ERROR) {
                    let error = translate('misc.api');

                    store.dispatch(setError(error));
                }

                if (status === HTTP_NOT_FOUND) {
                    isNotFound = true;
                }
            }
        }

        return {
            isError,
            errorMessage,
            data,
            pagination,
            isNotFound
        };
    }

    async get(options = {}) {
        this._validate();

        let url = `${this._url}/${this._apiMethod}`;
        this._apiMethod = false;

        let authConfig = Http._getAuthConfig();

        try {
            this._response = await this._axios.get(url, {
                params: {
                    ...options,
                    language: localStorage.getItem('lang') || process.env.DEFAULT_LANG
                },
                ...authConfig
            });
        } catch (e) {
            this._error = e.response?.data;

            return this.buildError(e.response?.status);
        }

        return this.build();
    }

    async getRaw(options = {}) {
        this._validate();

        let url = `${this._url}/${this._apiMethod}`;
        this._apiMethod = false;

        let authConfig = Http._getAuthConfig();

        try {
            this._response = await this._axios.get(url, {
                params: {
                    ...options,
                    language: localStorage.getItem('lang') || process.env.DEFAULT_LANG
                },
                ...authConfig
            });
        } catch (e) {
            this._error = e.response.data;

            return this.buildError(e.response.status);
        }

        return this._response;
    }

    async post(data = {}, convertToFormData = false) {
        this._validate();

        let url = `${this._url}/${this._apiMethod}`;
        this._apiMethod = false;

        let authConfig = Http._getAuthConfig();

        if (convertToFormData) {
            let formData = new FormData();
            Object.keys(data).forEach( key => formData.append(key, data[key]));
            data = formData;
        }

        if (data instanceof FormData) {
            data.append('language', localStorage.getItem('lang') || process.env.DEFAULT_LANG);
        } else {
            data.language = localStorage.getItem('lang') || process.env.DEFAULT_LANG;
        }

        try {
            this._response = await this._axios.post(url, data, authConfig);
        } catch (e) {
            this._error = e.response.data;

            return this.buildError(e.response.status);
        }

        return this.build();
    }

    async delete(data = {}) {
        this._validate();

        let url = `${this._url}/${this._apiMethod}`;
        this._apiMethod = false;

        let authConfig = Http._getAuthConfig();

        try {
            this._response = await this._axios.delete(url, {...authConfig, params: {...data}});
        } catch (e) {
            this._error = e.response.data;

            return this.buildError(e.response.status);
        }

        return this.build();
    }

    async put(data = {}) {
        this._validate();

        let url = `${this._url}/${this._apiMethod}`;
        this._apiMethod = false;

        let authConfig = Http._getAuthConfig();

        try {
            this._response = await this._axios.put(url, {
                ...data,
                language: localStorage.getItem('lang') || process.env.DEFAULT_LANG
            }, authConfig);
        } catch (e) {
            this._error = e.response.data;

            return this.buildError(e.response.status);
        }

        return this.build();
    }

    async patch(data = {}, convertToFormData = false) {
        this._validate();

        let url = `${this._url}/${this._apiMethod}`;
        this._apiMethod = false;

        let authConfig = Http._getAuthConfig();

        if (convertToFormData) {
            let formData = new FormData();
            Object.keys(data).forEach( key => formData.append(key, data[key]));
            data = formData;
        }

        try {
            this._response = await this._axios.patch(url, {
                ...data,
                language: localStorage.getItem('lang') || process.env.DEFAULT_LANG
            }, authConfig);
        } catch (e) {
            this._error = e.response.data;

            return this.buildError(e.response.status);
        }

        return this.build();
    }

    async export(options = {}, fileName) {
        this._validate();

        let url = `${this._url}/${this._apiMethod}`;
        this._apiMethod = false;

        let authConfig = Http._getAuthConfig();

        try {
            this._response = await this._axios.get(url, {
                params: {
                    ...options,
                    language: localStorage.getItem('lang') || process.env.DEFAULT_LANG
                },
                responseType: "blob",
                ...authConfig
            });
        } catch (e) {
            this._error = e.response.data;

            return this.buildError(e.response.status);
        }

        let response = this._response ? {...this._response} : false;
        this._response = false;

        if (response) {
            saveAs(new Blob([response.data], {type: response.headers['content-type']}), fileName);
        }
    }

    async download(data = {}, fileName = null) {
        return this.downloadPdf(data, fileName, true);
    }


    async downloadPdf(data = {}, fileName = null, exportTest = false) {
        this._validate();

        let url = `${this._url}/${this._apiMethod}`;
        this._apiMethod = false;

        let authConfig = Http._getAuthConfig();

        if (data instanceof FormData) {
            data.append('language', localStorage.getItem('lang') || process.env.DEFAULT_LANG);
        } else {
            data.language = localStorage.getItem('lang') || process.env.DEFAULT_LANG;
        }

        try {
            this._response = await this._axios.post(url, data, {...authConfig, responseType: 'arraybuffer'});
        } catch (e) {
            this._error = e.response.data;

            return this.buildError(e.response.status);
        }

        let response = this._response ? {...this._response} : false;
        this._response = false;

        if (response) {
            saveAs(new Blob([response.data], {type: response.headers['content-type']}), fileName || response.headers['x-filename']);
            return true;
        }
    }
}

export default new Http();
